


  
  

  var faFaceFrownSlight = {
    prefix: 'fal',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M480 256a224 224 0 1 0 -448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM190.6 379.3c-6.2 6.3-16.3 6.3-22.6 .1s-6.3-16.3-.1-22.6C190.4 334.1 221.5 320 256 320s65.6 14.1 88.1 36.7c6.2 6.3 6.2 16.4-.1 22.6s-16.4 6.2-22.6-.1C304.7 362.4 281.6 352 256 352s-48.7 10.4-65.4 27.3zM152 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fal',
    iconName: 'hand-fist',
    icon: [
      384,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M222.2 233.7c7.7 4 16.5 6.3 25.8 6.3 12.1 0 23.3-3.8 32.5-10.4 9.9 15.8 27.5 26.4 47.5 26.4 8.6 0 16.7-1.9 24-5.4l0 5.4c0 38.6-19.5 72.6-49.2 92.7-8.6 5.8-14.8 15.7-14.8 27.4L288 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-119.9 0-.1 .1-.1c.1-.2 .3-.5 .7-.7 38.1-25.9 63.2-69.6 63.2-119.2l0-104c0-30.9-25.1-56-56-56-8.6 0-16.7 1.9-24 5.4L304 88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8-7.3-22.5-28.4-38.8-53.3-38.8s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56l0 112c0 2.6 .2 5.1 .5 7.6-19.7 14.6-32.5 38-32.5 64.4 0 59 39.9 108.7 94.2 123.5 .8 .2 1.3 .6 1.6 1 .1 .2 .2 .3 .2 .3l0 0 0 99.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.3c0-16.3-11.9-28.4-25.4-32.1-40.7-11.1-70.6-48.4-70.6-92.6 0-26.5 21.5-48 48-48l88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c30.9 0 56-25.1 56-56 0-4.9-.6-9.7-1.8-14.3zM192 197.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 141.4zM112 192l-32 0c-5.5 0-10.8 .6-16 1.6L64 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104zm240 0l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40zM224 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faHandPointUp = {
    prefix: 'fal',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M64 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184-32 0c-5.5 0-10.8 .6-16 1.6L64 56zm48 216l56 0c13.2 0 24 10.7 24 24l0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 13.8 0 26.4-5 36.1-13.2 10.3 12.9 26.1 21.2 43.9 21.2 8.6 0 16.7-1.9 24-5.4-1.4 69.5-58.2 125.4-128 125.4l-64 0C89.3 480 32 422.7 32 352l0-32c0-26.5 21.5-48 48-48l32 0zm32-32l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 45.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0zm0-90.6L144 56c0-30.9-25.1-56-56-56S32 25.1 32 56l0 200C12.6 270.6 0 293.8 0 320l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-104c0-30.9-25.1-56-56-56-12.1 0-23.3 3.8-32.5 10.4-9.9-15.8-27.5-26.4-47.5-26.4-9.7 0-18.8 2.5-26.7 6.8-7.3-22.5-28.4-38.8-53.3-38.8-8.6 0-16.7 1.9-24 5.4zM224 272l0-40c0-13.2 10.8-24 24-24 13.3 0 24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24zm128 0l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24z'
      
    ]
  };

  



export {

  faFaceFrownSlight,
  

  faHandFist,
  
  faFistRaised,
  

  faHandPointUp,
  

};
